import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['permissionsCheckBox', 'permissionsAttributes'];

  connect() {
    this.togglePermissions();
  }

  togglePermissions() {
    const checkbox =
      this.hasPermissionsCheckBoxTarget &&
      this.permissionsCheckBoxTarget.querySelector('input[type="checkbox"]');

    if (!checkbox) return;

    const isChecked = checkbox.checked;
    this.permissionsAttributesTarget.hidden = !isChecked;

    // Disable all permission checkboxes when hidden
    const permissionCheckboxes =
      this.permissionsAttributesTarget.querySelectorAll(
        'input[type="checkbox"]',
      );
    permissionCheckboxes.forEach((cb) => {
      cb.disabled = !isChecked;
    });
  }
}
